// extracted by mini-css-extract-plugin
module.exports = {"container":"PersonalData_container__1sQRF","container__mobile":"PersonalData_container__mobile__3fwV-"};